import { Application } from './Application';

export class ApplicationTile extends Application {
    isFavorite?: boolean;
    isHidden: boolean;
}
